import _extends from "@babel/runtime/helpers/extends";
import { forwardRef } from "react";
import hintCss from "hint.css/hint.min.css?inline-raw";
import { usePlainCss } from "../hooks";

/**
 * This is a very basic `hint.css` implementation for a tooltip.
 *
 * @see https://kushagra.dev/lab/hint/
 */
// eslint-disable-next-line react/display-name
const Tooltip = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    className,
    title,
    position = "top",
    color,
    size = "large",
    always,
    rounded,
    noAnimate,
    bounce,
    ...rest
  } = _ref;
  usePlainCss(hintCss, "hint-css", true);
  return h("div", _extends({
    style: {
      position: "relative",
      display: "inline"
    },
    ref: ref,
    "aria-label": title,
    className: `hint--${position} hint--${size} ${color ? `hint--${color}` : ""} ${always ? `hint--always` : ""} ${rounded ? `hint--rounded` : ""} ${noAnimate ? `hint--no-animate` : ""} ${bounce ? `hint--bounce` : ""} ${className || ""}`
  }, rest), children);
});
export { Tooltip };